module.exports = __webpack_public_path__ + "img/spiro.ad147503.png";